import { StrapiPages } from "@lib/strapi/pages";
import { StrapiResponse } from "@lib/strapi/dtos/core/response.dto";
import { StrapiRoutes } from "@lib/strapi/routes";
import {
  StrapiSiteSettingsDTO,
  SiteSettingsDTO,
} from "@lib/strapi/dtos/content-types/siteSettings.dto";
import { fetchAPI } from "@lib/strapi/fetch-api";

export class SiteSettingsService {
  static async fromStrapi(
    dto: SiteSettingsDTO,
    locale: string,
    strapiData?: StrapiSiteSettingsDTO,
  ): Promise<SiteSettingsDTO> {
    if (!strapiData) {
      return null;
    }
    if (dto == null) {
      dto = new SiteSettingsDTO();
    }
    dto.legalName = strapiData.legalName;
    dto.telephone = strapiData.telephone;
    dto.mobile = strapiData.mobile;
    dto.email = strapiData.email;
    dto.addressStreet = strapiData.addressStreet;
    dto.addressLocality = strapiData.addressLocality;
    dto.addressPostalCode = strapiData.addressPostalCode;
    dto.workingHours = strapiData.workingHours;
    dto.hoursOpens = strapiData.hoursOpens;
    dto.hoursCloses = strapiData.hoursCloses;
    dto.hoursDays = strapiData.hoursDays;
    dto.bookAppointmentPrompt = strapiData.bookAppointmentPrompt;
    dto.googleMapsUrl = strapiData.googleMapsUrl;
    dto.googleBusinessProfileUrl = strapiData.googleBusinessProfileUrl;
    dto.googleWriteReviewUrl = strapiData.googleWriteReviewUrl;
    dto.eopyyContracted = strapiData.eopyyContracted;
    return dto;
  }

  static async fetchSingle(
    authToken: string,
    locale: string,
  ): Promise<SiteSettingsDTO> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = { locale };
    const response: StrapiResponse<StrapiSiteSettingsDTO> = await fetchAPI(
      StrapiRoutes.siteSetting(),
      urlParamsObject,
      token,
    );
    const dto = new SiteSettingsDTO();
    return response.data == null
      ? null
      : await SiteSettingsService.fromStrapi(dto, locale, response.data);
  }
}
